import { render, staticRenderFns } from "./bottom_confirm.vue?vue&type=template&id=3a4355df&scoped=true&"
import script from "./bottom_confirm.vue?vue&type=script&lang=js&"
export * from "./bottom_confirm.vue?vue&type=script&lang=js&"
import style0 from "./bottom_confirm.vue?vue&type=style&index=0&id=3a4355df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4355df",
  null
  
)

export default component.exports